const ICONES = 'assets/icones';

export interface IconeContatoDisparo {
  tipo: 'mat' | 'img';
  valor: string;
  classe?: string;
  tooltip: string;
}

interface ContatoStatus {
  status?: unknown;
  statusEnvio?: unknown;
  statusEnvioIntegracao?: unknown;
  motivoErro?: string;
  motivoErroIntegracao?: string;
}

function normalizar(valor: unknown): string {
  return (valor ?? '').toString().toUpperCase();
}

export function iconeStatusContatoDisparo(
  tipoDisparo: string | null | undefined,
  contato: ContatoStatus | null | undefined,
): IconeContatoDisparo | null {
  if (!contato) return null;
  const canal = (tipoDisparo ?? '').toString().toLowerCase();

  if (canal === 'email' || canal === 'sms') {
    const iconesStatus = canal === 'sms'
      ? {
          enviado: `${ICONES}/icone-sms-status-verde.svg`,
          falhou: `${ICONES}/icone-sms-status-red.svg`,
          pendente: `${ICONES}/icone-sms-status-roxo.svg`,
          processando: `${ICONES}/icone-sms-status-roxo.svg`,
        }
      : {
          enviado: `${ICONES}/email-verde-envio.svg`,
          falhou: `${ICONES}/email-erro-envio.svg`,
          pendente: `${ICONES}/email-pendente-roxo.svg`,
          processando: `${ICONES}/email-processando-laranja.svg`,
        };
    switch (normalizar(contato.statusEnvio)) {
      case 'ENVIADO':
        return {
          tipo: 'img',
          valor: iconesStatus.enviado,
          tooltip: 'Enviado',
        };
      case 'FALHOU':
        return {
          tipo: 'img',
          valor: iconesStatus.falhou,
          tooltip: contato.motivoErro || 'Falha no envio',
        };
      case 'CANCELADO':
        return {
          tipo: 'img',
          valor: iconesStatus.falhou,
          tooltip: contato.motivoErro || 'Envio cancelado',
        };
      case 'EM_PROCESSAMENTO':
        return { tipo: 'img', valor: iconesStatus.processando, tooltip: 'Em processamento' };
      case 'BLOQUEADO_BLACKLIST':
        return {
          tipo: 'img',
          valor: `${ICONES}/email_blacklist_icon.svg`,
          tooltip: contato.motivoErro || 'Envio pulado: e-mail está na blacklist',
        };
      case 'BLOQUEADO_BLACKLIST_DOMINIO':
        return {
          tipo: 'img',
          valor: `${ICONES}/email_blacklist_icon.svg`,
          tooltip: contato.motivoErro || 'Envio pulado: domínio do e-mail está na blacklist',
        };
      case 'EMAIL_INVALIDO':
        return {
          tipo: 'img',
          valor: `${ICONES}/redesign/modulos/disparos/contato-pulado.svg`,
          tooltip: contato.motivoErro || 'Envio pulado: e-mail inválido',
        };
      default:
        return { tipo: 'img', valor: iconesStatus.pendente, tooltip: 'Pendente' };
    }
  }

  switch (normalizar(contato.status)) {
    case 'SENT':
      return { tipo: 'mat', valor: 'check', tooltip: 'Enviado' };
    case 'DELIVERED':
      return { tipo: 'mat', valor: 'done_all', tooltip: 'Entregue' };
    case 'READ':
      return {
        tipo: 'mat',
        valor: 'done_all',
        classe: 'status-lido',
        tooltip: 'Lido',
      };
    case 'FAILED':
    case 'ERRO':
      return {
        tipo: 'mat',
        valor: 'error',
        classe: 'status-erro',
        tooltip: contato.motivoErro || 'Falha no envio',
      };
    case 'CANCELADO':
      return {
        tipo: 'mat',
        valor: 'cancel',
        classe: 'status-erro',
        tooltip: contato.motivoErro || 'Envio cancelado',
      };
    case 'POSSUE_SESSAO':
      return {
        tipo: 'img',
        valor: `${ICONES}/conato-possue-sessao.svg`,
        tooltip: 'Contato já possui sessão aberta',
      };
    default:
      return {
        tipo: 'img',
        valor: `${ICONES}/whatsapp-clock-cinza.svg`,
        tooltip: 'Aguardando envio',
      };
  }
}

export function iconeIntegracaoContatoDisparo(
  contato: ContatoStatus | null | undefined,
): IconeContatoDisparo | null {
  if (!contato) return null;
  switch (normalizar(contato.statusEnvioIntegracao)) {
    case 'ENVIADO':
      return {
        tipo: 'img',
        valor: `${ICONES}/integ-verde.svg`,
        tooltip: 'Integração concluída',
      };
    case 'FALHOU':
      return {
        tipo: 'img',
        valor: `${ICONES}/integ-vermelho.svg`,
        tooltip: contato.motivoErroIntegracao || 'Falha na integração',
      };
    case 'CANCELADO':
      return {
        tipo: 'img',
        valor: `${ICONES}/integ-cinza.svg`,
        tooltip: contato.motivoErroIntegracao || contato.motivoErro || 'Integração cancelada',
      };
    case 'PENDENTE':
    case 'EM_PROCESSAMENTO':
      return {
        tipo: 'img',
        valor: `${ICONES}/integ-roxo.svg`,
        tooltip: 'Integração em processamento',
      };
    case 'AGUARDANDO_MENSAGEM':
      return {
        tipo: 'img',
        valor: `${ICONES}/integ-cinza.svg`,
        tooltip: 'Aguardando envio da mensagem',
      };
    default:
      return {
        tipo: 'img',
        valor: `${ICONES}/integ-cinza.svg`,
        tooltip: 'Integração aguardando',
      };
  }
}
